import { Grid, styled } from '@mui/material';

export const BaseGrid = styled(Grid)(({ theme }) => ({
  '& .CustomSortableTable-destructiveButton:hover': {
    color: `${theme.palette.error.main} !important`,
  },
}));
